<template>
	<div class="search-component">
		<div class="search-input">
			<van-search
			v-model="searchKeyWords"
			show-action
			placeholder="请输入搜索关键词"
			@search="search"
			>
			<template #action>
				<div @click="search">搜索</div>
			</template>
		</van-search>
			<!-- <van-search placeholder="请输入搜索关键词" v-model="searchKeyWords" @search="search"/> -->
		</div>		
	</div>
</template>
<script>
	export default{
		props:{
			keyWords:String,
			url:String
		},
		data(){
			return{
				searchKeyWords:this.keyWords
			}
		},
		mounted(){
			
		},
		watch:{
			keyWords(newName,oldName){
				this.searchKeyWords=newName;
			},
			searchKeyWords(newName,oldName){
				
				if(newName==''&&this.url){
					this.$router.push({
							name:this.url,
							params:{active:1}
					})
				}else if((newName=='')&&(!this.url)){
					this.$emit('goSearch',this.searchKeyWords)
				}
			}
		},
		mounted(){
			
		},
		methods:{
			//搜索
			search(){
				this.$emit('goSearch',this.searchKeyWords)
			}
		}
	}
</script>
<style lang="scss">
	.search-component{
		.search-input{
				.van-search__content{
					background: #FFFFFF;
					border: 1px solid #D3D3D3;
					border-radius: 3px;
					::-webkit-input-placeholder,i{
						color:#999;
						font-size:14px;
					}
					i{
						font-size:20px;
					}
				}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue